const message = Object.freeze({
  HELP_TEXT: `Se enviarán por email las actas seleccionadas a la dirección de correo configurada para cada una.
  Para editar un destinatario, puede hacer click en la tabla.`,
});

export default message;